import convertNode from "../convertNode";

export default function parseDefinitionDetail(xmlNode) {
  return {
    type: "definition_detail",
    content: Array.from(xmlNode.children).map(convertNode),
  };
}
